export default {
  dashboard: "Dashboard",
  users: "Benutzer",
  adminActivities: "Aktivitäten",
  adminStructures: "Strukturen",
  activities: "Aktivitäten",
  myHouses: "Meine Strukturen",
  bookings: "Buchungen",
  partnersAndHosts: "Verkäufer & Gastgeber",
  wallet: "Wallet",
  points: "Punkte",
  settings: "Einstellungen",
  helpSupport: "Hilfe & Support",
  devices: "Geräteverwaltung",
  devicesList: "Geräte",
  devicesPresets: "Gerätevorlagen",
  devicesCarousel: "Karussell",
  devicesStatistics: "Statistiken",
  readers: "Kartenleser",
  supportTickets: "Nutzer-Support",
  supportTicketsList: "Partner-Tickets",
  supportChats: "Kunden-Chats",
  adminPayments: "Buchhaltung",
  adminPaymentsEvents: "Wirtschaftliche Ereignisse",
  adminPaymentsExternal: "Externe Zahlungen",
  adminPaymentsSettlements: "Abrechnungen",
  adminNotifications: "Benachrichtigungen",
  adminProtocols: "Protokolle",
  adminAgentTranscripts: "Sprachtranskripte",
  adminNotificationsOpen_one: "{{count}} offene Benachrichtigung",
  adminNotificationsOpen_other: "{{count}} offene Benachrichtigungen",
  bookingsNew_one: "{{count}} neue Buchung",
  bookingsNew_other: "{{count}} neue Buchungen",
  completeProfile: "Profil vervollständigen",
  completeProfileTitle: "Rechtliches Profil unvollständig",
  completeProfileDescription:
    "Solange Ihr rechtliches Profil unvollständig ist, können Ihre Aktivitäten Kunden im Katalog nicht angezeigt werden.",
  completeProfileLink: "Profil vervollständigen →",
  logout: "Abmelden",
  impersonating: "Identitätswechsel aktiv",
  stopImpersonating: "Identitätswechsel beenden",
  logoutWhileImpersonatingTitle: "Sie agieren als {{name}}",
  logoutWhileImpersonatingMessage:
    "Möchten Sie den Identitätswechsel beenden oder sich abmelden?",
  groups: {
    overview: "Übersicht",
    management: "Verwaltung",
    operations: "Betrieb",
    finance: "Finanzen",
    account: "Konto",
  },
  theme: {
    switchToLight: "Zum hellen Design wechseln",
    switchToDark: "Zum dunklen Design wechseln",
  },
  search: "Suchen…",
  openMenu: "Menü öffnen",
  closeMenu: "Menü schließen",
  breadcrumb: "Navigationspfad",
} as const;
